module.exports = __webpack_public_path__ + "static/linkedinAlpha.24725531.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/linkedinAlpha.png
// module id = 1157
// module chunks = 79611799117203